import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { fbAuth } from "../util";
import { Link } from "react-router-dom";
class Reset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      error: null,
    };
  }
  handleSubmit = e => {
    e.preventDefault();
    console.info(this.state);
    fbAuth
      .sendPasswordResetEmail(this.state.email, {
        url: "https://dww.netlify.app",
      })
      .then(() => {
        this.setState({ success: true });
      })
      .catch(function (error) {
        this.setState({ error: true });
      });
  };
  handleKeyUp = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };
  render() {
    const { error, success } = this.state;
    if (success) {
      return (
        <>
          <h1>Please check your email.</h1>
        </>
      );
    }
    return (
      <Form onSubmit={this.handleSubmit}>
        <h1>Reset Password</h1>
        {error && <p>Error: {error}</p>}
        <FormGroup>
          <Label>Email</Label>
          <Input type="email" name="email" onChange={this.handleKeyUp} />
        </FormGroup>
        <FormGroup>
          <Button color="primary">Reset Password</Button>
        </FormGroup>
      </Form>
    );
  }
}

export default Reset;
